import React from 'react';
import {Application} from "../../../application/MainApp";
import {connect} from "react-redux";
import {setBreadcrumbs} from "../../root/root.actions";
import {FunctionPageForm} from "./components/functionPageNew";
import {CreateFunctionForm} from "./components/functionCreateFunction";
import {withTranslation} from "react-i18next";
import {FunctionTemplatesForm} from "./components/functionFunctionTemplates";
import { withRouter } from '../../utils/withRouter';

const FunctionComponent = (props) => {
    props.setBreadcrumbs(props.match);
    document.title = props.t('common.functions') + " - " + props.t('common.title');

    let page = <></>

    if (props.match.url === "/function") {
        page = <FunctionPageForm/>
    }
    else if (props.match.url.startsWith("/function/createFunction")) {
        const split = props.match.url.split("/");
        let functionId = null;
        let action = null;
        let shared = false;
        if (split.length > 3) {
            functionId = split[split.length-1];
            action = split[split.length-2];
        }
        if (action === null) {
            action = "create"
        }
        else {
            if (action === 'view-shared') {
                shared = true;
                action = 'view';
            }
            else if (action === 'edit-shared') {
                shared = true;
                action = 'edit';
            }
        }
        page = <CreateFunctionForm functionId={functionId} action={action} shared={shared}/>
    }
    else if(props.match.url.startsWith('/function/share')) {
        const split = props.match.url.split("/");
        let shareCode = null;
        let action = null;
        if (split.length > 3) {
            shareCode = split[split.length-1];
            action = split[split.length-2];
        }
        if (action === null) {
            action = "share"
        }
        page = <CreateFunctionForm shareCode={shareCode} action={action} />
    }
    else if (props.match.url === "/function/functionTemplates") {
        page = <FunctionTemplatesForm editorActivated={true} />
    }

    return (
        <Application>
            {page}
        </Application>
    );
}

const mapStateToProps = (state) => {
    return {
        userSettings: state.user.userSettings,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setBreadcrumbs: (match) => dispatch(setBreadcrumbs(match)),
    };
}

export const Func = connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation('translation')(withRouter(FunctionComponent)));